// @ts-nocheck
import { createTheme, alpha } from '@mui/material/styles';
import _ from 'lodash';
import baseTheme from './base';
// The palette enables you to modify the color of the components to suit your brand.
// https://material-ui.com/customization/palette/
// https://material-ui.com/customization/default-theme/?expand-path=$.palette
// export default createTheme({
//   ...baseTheme,
//   themeName: 'Nimbus Light',
// });

const THEME_PALETTE = {
  mode: 'light',
  type: 'light',
  primary: {
    main: '#272D55',
  },
  secondary: {
    main: '#AECDFC',
  },
  success: {
    light: '#52BE7F',
    main: '#058234',
    dark: '#1B7943',
    contrastText: '#000000',
    successTask: '#25AF60',
  },
  error: {
    main: '#EB5757',
    light: '#EF7878',
    dark: '#A43C3C',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#D08329',
    light: '#FBBE76',
    dark: '#AF793A',
    contrastText: '#000000',
  },
  info: {
    main: '#D08329',
    light: '#FBBE76',
    dark: '#AF793A',
    contrastText: '#000000',
  },
  divider: '#CACACA',
  other: {
    multipleSnackBarBg: '#3A3D54',
    listTableRowSelectedBg: '#F0F0F0',
    sidebar: '#ffffff',
    sidebarMenuHover: '#FFFFFF4D',
    sidebarMenuSelected: '#e3e3e3',
    navbar: '#ffffff',
    icon: '#1D1D1D',
    loaderBackground: '#1E1919',
    subHeading: '#E5F6FD',
    menuItemColor: '#ffffff',
    menuBackground: '#ffffff',
    groupHeading: '#F4F4F4',
    blue1: '#e3e3e3',
    blue2: '#F3F5FF',
    blue8: '#AEC9F64D',
    lightBrandBlueLogin: '#84AFEF',
    hover: '#E8F1FF',
    white: '#FFFFFF',
    white2: '#ddd',
    black: '#000000',
    grey1: '#F4F4F4',
    grey2: '#9396AA',
    gray3: '#E5E8FA',
    purple: '#963DEE',
    grey6: '#636363',
    grey8: '#8F8F8F',
    lightGrey: '#E9E9E9',
    darkGrey: '#344054',
    loginSecondaryColor: '#DFE7F3',
    lightGreen: '#ECFDF3',
    lightRed: '#FEF3F2',
    lightGreen1: '#12B76A',
    lightRed1: '#F04438',
    lightGreen2: '#027A48',
    lightRed2: '#B42318',
    red: '#FF1809',
    tableCell: '#ffffff',
    green1: '#3cf4ff',
    groupBg: '#ffffff',
    pieChart1: '#EBF0B1',
    pieChart2: '#EE9023',
    pieChart3: '#ACB9FD',
    pieChart4: '#BDEDDA',
    pieChart5: '#F4B2B6',
    pieChart6: '#AAD6FF',
    pieChart7: '#F9BCE4',
    pieChart8: '#FFD3B4',
    pieChart9: '#A6DCFB',
    pieChart10: '#B3F0F0',
    pieChart11: '#EBF0B1',
    pieChart12: '#D4BCF2',
    pieChart13: '#FDE5AA',
    pieChart14: '#EDB777',
    barChart1: '#DEF0B8',
    barChart2: '#BDEDDA',
    barChart3: '#B3F0F0',
    barChart4: '#F4B2B6',
  },
  text: {
    primary: '#282828',
    disabled: '#9396AA',
    contrastText: '#1A1A1A',
    placeholder: '#525252',
    inactiveTab: '#434343',
    toolbarOption: '#595959',
  },
  background: {
    default: '#F9F9F9',
    paper: '#ffffff',
  },
  action: {
    active: '#272D55',
    hover: '#e3e3e3',
    selected: '#E3E3E3',
    disabled: '#CACACA',
    disabledBackground: '#F0F0F0',
    focus: '#272D55',
  },
  loginPage: {
    background: '#ffffff',
    loginFormBorder: '#E5E7EB',
  },
};

const LIGHT_THEME = {
  themeName: 'Nimbus Light',
  palette: THEME_PALETTE,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          '&::-webkit-scrollbar-thumb': {
            background: '#CACACA',
          },
        },
        '.ProseMirror pre': {
          backgroundColor: '#141A3F',
          color: '#f6f1f1',
        },
        '.ProseMirror .wrapperDiv-placeholder': {
          backgroundColor: '#F3F5FF',
          color: '#1A1A1A !important',
        },
        '.ProseMirror .placeholder-decoration': {
          color: '#ffffff',
          backgroundColor: ' #272D55',
        },
        '.ProseMirror .selected-cell-decoration': {
          backgroundColor: 'rgba(227, 236, 255, 1)',
          borderColor: ' #272D55',
        },
        '.ProseMirror table': {
          borderColor: '#84AFEF',
        },
        '.tiptap table td.selectedCell': {
          backgroundColor: '#dfdfdf !important',
        },
        '.tiptap table th.selectedCell': {
          backgroundColor: '#dfdfdf !important',
          color: '#000 !important',
        },
        '.menuBarTiptap .is-active': {
          backgroundColor: '#E5E5E5',
        },
        'img.ProseMirror-selectednode': {
          borderColor: '#272D55',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
        },
      },
    },

    MuiAutocomplete: {
      styleOverrides: {
        popupIndicator: {
          color: '#272D55',
        },
        option: {
          '&.Mui-focused': {
            backgroundColor: '#f5f5f5 !important',
          },
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
        },
      },
    },

    MuiDialog: {
      styleOverrides: {
        paper: {
          // backgroundColor: '#F3F5FF',
          // boxShadow: '0px 6px 12px rgba(132, 175, 239, 0.31)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: alpha('#AECDFC', 0.5),
        },
        colorSecondary: {
          borderColor: '#84AFEF',
        },
        root: {
          '&:hover': {
            backgroundColor: '#AECDFC',
          },
          '&:focus': {
            backgroundColor: '#AECDFC',
          },
          '&:focus-visible': {
            outlineColor: '#000000',
          },
          '&.job-queue-chip-active': {
            backgroundColor: alpha('#AECDFC', 0.5),
          },
          '&.job-queue-chip': {
            backgroundColor: '#FFFFFF',
          },
        },
        label: {
          color: '#272D55',
        },
        deleteIconColorPrimary: {
          color: '#272D55',
          '&:hover': {
            color: '#272D55',
          },
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#272D55 !important',
          '&.list-table-header': {
            backgroundColor: '#E3E3E3 !important',
            color: '#282828 !important',

            '& .MuiCheckbox-root': {
              color: '#272D55',
            },
            '& .Mui-checked': {
              color: '#272D55',
            },
            '& .MuiTableSortLabel-root': {
              backgroundColor: 'transparent',
              '& svg': {
                fill: '#272D55 !important',
              },
            },
          },
        },

        root: {
          // borderColor: THEME_PALETTE.secondary.dark,
          background: '#FFFFFF',
          '&.MuiTablePagination-root': {
            background: 'transparent',
          },
          '&.list-table-cell': {
            borderColor: '#CACACA',
          },
        },
        sizeMedium: {
          '&.list-table-cell': {
            borderColor: '#CACACA',
          },
        },

        sizeSmall: {
          borderColor: '#CACACA',
          '&:hover': {
            backgroundColor: '#F0F0F0',
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          borderColor: '#272D55',
          '& .MuiTableSortLabel-root': {
            backgroundColor: 'transparent',
            '& svg': {
              fill: '#FFFFFF !important',
            },
          },

          '&.MuiTableHead-bg th': {
            borderTop: '1px solid',
            backgroundColor: '#272D55 !important',

            '&:hover': {
              backgroundColor: '#272D55 !important',
            },
          },
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        icon: {
          color: '#AECDFC !important',
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          borderColor: '#CACACA',
        },
      },
    },

    MuiTablePagination: {
      styleOverrides: {
        root: {
          '& .MuiTablePagination-toolbar': {
            background: '#F9F9F9 !important',

            '& select': {
              background: 'transparent',
            },
          },
        },
        select: {
          // background: '#FFFFFF',
          '&:focus-visible': {
            outlineColor: '#000000',
          },
        },
        actions: {
          '& button:focus-visible': {
            outlineColor: '#000000',
          },
        },
        toolbar: {
          // background: '#F3F5FF',
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        previousNext: {
          background: '#FFFFFF !important',
        },
        root: {
          '&:focus-visible': {
            outlineColor: '#000000 !important',
          },
        },
      },
    },

    MuiLinearProgress: {
      styleOverrides: {
        barColorPrimary: {
          backgroundColor: '#272D55 !important',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#393939 !important',
          '&.Mui-focused': {
            color: '#393939 !important',
          },
          '&.Mui-error': {
            color: '#C21919 !important',
          },
          '&.Mui-disabled': {
            color: '#9396AA !important',
          },
        },
      },
    },

    MuiFormControl: {
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root': {
            color: '#000',
            '&.Mui-error': {
              color: '#C21919 !important',
            },
            '& .MuiTypography-root': {
              color: '#000',
            },
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root': {
            color: '#393939',
          },
          '& .MuiInputLabel-shrink': {
            color: '#000',
          },
          '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline':
            {
              borderColor: 'rgba(0, 0, 0, 0.38)',
            },
        },
      },
    },
    MuiBox: {
      styleOverrides: {
        root: {
          backgroundColor: 'none',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          borderColor: '#CACACA',
          // '& .Mui-selected': {
          //   color: '#141A3F !important',
          // },
        },

        indicator: {
          boxShadow: '0px -2px 14px rgba(39, 45, 85, 0.24)',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: '#AAACBB',
        },
      },
    },
    // MuiButton: {
    // 	styleOverrides: {
    // 		outlinedSizeLarge: {
    // 			color: '#AECDFC !important',
    // 		},
    // 		containedSecondary: {
    // 			color: '#141A3F !important',
    // 		},
    // 	},
    // },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outlineColor: '#000000',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outlineColor: '#000000',
          },
          '&.Mui-SearchPaginationAction': {
            backgroundColor: '#272D55',
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: '#1B1F3B',
            },
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: '#272D55',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#272D55',
          '&.Mui-focusVisible': {
            backgroundColor: '#D9D9D9',

            '& .MuiSvgIcon-root': {
              backgroundColor: 'white',
            },
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        track: {
          '&.Mui-checked': {},
        },
        thumb: {
          borderColor: '#272D55 !important',
          '&.Mui-checked': {
            backgroundColor: '#272D55 !important',
          },
        },
        input: {
          '&:focus-visible + .MuiSwitch-thumb': {
            outlineColor: '#000000',
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          borderBottomColor: '#84AFEF',
          '& .MuiListItemButton-root': {
            '& .list-item-button-hover-actions-right': {
              backgroundImage:
                'linear-gradient(269.82deg, #DDE9FF 68.25%, rgba(200, 222, 255, 0.1) 87.71%)',
            },
            '&:hover': {
              backgroundColor: '#C8DEFF',
            },
          },
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        select: {
          backgroundColor: '#ffffff ',
        },
        icon: {
          color: '#272D55 !important',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: '#393939',
          '&.Mui-error': {
            color: '#C21919',
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: '#C21919',
          '&.Mui-error': {
            color: '#C21919',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderColor: '#BCBCBC !important',
          backgroundColor: '#FFFFFF !important',
          '& fieldset': {
            border: 'none',
          },
          '&:hover': {
            borderColor: '#BCBCBC !important',
          },
          '&.Mui-focused': {
            borderColor: '#141E62 !important',
          },
          '&.Mui-error': {
            borderColor: '#C21919 !important',
            '& .MuiFormHelperText-root': {
              color: '#C21919 !important',
            },
          },
          '&.Mui-disabled': {
            color: '#E9E9E9 !important',
          },
        },
        input: {
          color: '#393939 !important',
          '&::placeholder': {
            color: '#525252 !important',
            opacity: 1,
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF !important',
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          color: '#272D55',
        },
        track: {
          backgroundColor: '#272D55',

          borderColor: '#272D55',
        },
        rail: {
          backgroundColor: '#FFFFFF',

          borderColor: '#272D55',
        },
        valueLabel: {
          color: '#FFFFFF',
          background: '#272D55',
        },
        mark: {
          background: '#272D55 !important',
        },
        markLabel: {
          color: '#272D55 !important',
        },
        thumb: {
          '&:hover': {
            boxShadow: `0px 0px 0px 15px ${alpha('#AECDFC', 0.5)} !important`,
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: alpha('#AECDFC', 0.4),
          '&.permission-accordion': {
            backgroundColor: alpha('#AECDFC', 0.1),
          },

          '&:before': {
            backgroundColor: 'transparent !important',
          },
          '&.job-queue-accordion': {
            borderColor: '#BCBCBC',
            '& .MuiAccordionDetails-root': {
              backgroundColor: 'transparent',
            },
          },
          '&.job-queue-accordion-read': {
            backgroundColor: '#FFFFFF',
          },
          '&.job-queue-accordion-unread': {
            backgroundColor: alpha('#AECDFC', 0.2),
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          background: '#272D55',
          color: '#FFFFFF !important',
          '& .MuiTypography-root': {
            color: '#FFFFFF !important',
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:hover': '#e3e3e3',
        },
      },
    },
  },
};

export const lightTheme = LIGHT_THEME;
export default createTheme(_.merge(_.cloneDeep(baseTheme), LIGHT_THEME));
